import { useEffect, useState } from "react";
import * as React from 'react';
import {
  Box,
  Button,
  TextField,
  Typography,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import Logo from "../assets/images/VBM_LOGO_FULL.png";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import { styled } from "@mui/material/styles";
import SpaTwoToneIcon from "@mui/icons-material/SpaTwoTone";
import Autocomplete from "@mui/material/Autocomplete";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import HouseIcon from '@mui/icons-material/OtherHouses';
import UploadIcon from '@mui/icons-material/FileUpload';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import CloseIcon from '@mui/icons-material/Close';
import SprayIcon from '@mui/icons-material/Shower';
import { IApplication } from "../interfaces/IApplication";
import { setBackgroundPath, setPageTitle } from "../slices/applicationSlice";
import { useAppSelector, useAppDispatch } from "../hooks";
import ReceiptIcon from '@mui/icons-material/ReceiptLong';
import ModuleMenu from "../components/ModuleMenu";
import { MainBackground } from "../assets/images/backgrounds";
import ShippingIcon from '@mui/icons-material/LocalShipping';
import SeedingIcon from '@mui/icons-material/LocalFlorist'
import InvoiceIcon from '@mui/icons-material/RequestPage';
import SignpostIcon from '@mui/icons-material/Signpost';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

export interface DialogTitleProps {
  id: string;
  children?: React.ReactNode;
  onClose: () => void;
}

function BootstrapDialogTitle(props: DialogTitleProps) {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2, }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
}

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? '#666666' : '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'center',
  color: theme.palette.text.secondary,
  border: 0,
  borderRadius: 0,
  boxShadow: "none",
}));

const availableModules = [
  { label: "Patching", route: "/patching/dashboard" },
  { label: "Space Allocation", route: "/main/spaceallocationdashboard" },
  { label: "Tray Import", route: "/main/trayimportdashboard" },
  { label: "User Management", route: "/hr/usersdashboard" },
  { label: "Inventory", route: "/main/inventorydashboard" },
  { label: "Growing", route: "/main/growingdashboard" },
  { label: "Logistics", route: "/logistics/dashboard" },
  { label: "Invoicing", route: "/invoicing/dashboard" },
  { label: "Shipping", route: "/shipping/dashboard" },
  { label: "Purchase Orders", route: "/po/podashboard" },
];

export default function MainDashboard() {
  const dispatch = useAppDispatch();
  const userSelector = useAppSelector((state) => { return state.application.loggedInUser })
  useEffect(() => {

    let appState: IApplication = {
      pageTitle: "Main Dashboard",
      backgroundPath: MainBackground
    }
    dispatch(setPageTitle(appState));
    dispatch(setBackgroundPath(appState));
  }, []);

  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === "dark" ? "#999" : "#fff",
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: "center",
    color: theme.palette.text.secondary,
  }));


  const moduleChanged = (event: any, newValue: any | null) => {
    console.log(newValue);
    navigate(newValue.route);
  };

  const navigate = useNavigate();

  return (
    <div className="wrapper">
      <section className="loginArea">
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          paddingTop={5}
        >
          <img src={Logo} height="125px" />
        </Box>
        <Box display="flex"
          justifyContent="center"
          alignItems="center"
          marginTop={6}><Typography variant="h3">Welcome {userSelector?.firstName}!</Typography>
        </Box>
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          marginTop={4}
          marginBottom={8}
        >
          <Paper
            component="form"
            sx={{
              p: "2px 4px",
              display: "flex",
              alignItems: "center",
              width: 700,
              boxShadow: 12,
            }}
          >
            <Autocomplete
              disablePortal
              id="combo-box-demo"
              options={availableModules}
              sx={{ width: "100%" }}
              renderInput={(params) => <TextField {...params} label="Select a Module" />}
              onChange={(e, newValue) => { moduleChanged(e, newValue) }}
            />
            <Divider sx={{ height: 28, m: 0.5 }} orientation="vertical" />
            <IconButton sx={{ p: "10px" }} aria-label="menu" onClick={handleClickOpen}>
              <MenuIcon />
            </IconButton>
          </Paper>
        </Box>
        <Box sx={{ flexGrow: 1, mt: 3 }}>
          <Grid container spacing={1} sx={{ padding: 2 }}>
            <Grid item xs={12} md={3}>
              <Item sx={{ padding: 0, bgcolor: 'transparent', boxShadow: 'none' }}>
                <Button
                  sx={{ minHeight: 120, borderRadius: '20px', boxShadow: 12, border: "2px solid #FFF" }}
                  fullWidth
                  variant="contained"
                  size="large"
                  startIcon={<SpaTwoToneIcon sx={{ width: 55, height: 55, color: "#89B219" }} />}
                  onClick={() => navigate("/patching/dashboard")}
                >
                  <Typography variant="h5" fontWeight="700">PATCHING</Typography>
                </Button>
              </Item>
            </Grid>
            <Grid item xs={12} md={3}>
              <Item sx={{ padding: 0, bgcolor: 'transparent', boxShadow: 'none' }}>
                <Button
                  sx={{ minHeight: 120, borderRadius: '20px', boxShadow: 12, border: "2px solid #FFF" }}
                  fullWidth
                  variant="contained"
                  size="large"
                  startIcon={<HouseIcon sx={{ width: 45, height: 45, color: "#89B219" }} />}
                  onClick={() => navigate("/main/spaceallocationdashboard")}
                >
                  <Typography variant="h5" fontWeight="700">SPACE ALLOCATION</Typography>
                </Button>
              </Item>
            </Grid>
            <Grid item xs={12} md={3}>
              <Item sx={{ padding: 0, bgcolor: 'transparent', boxShadow: 'none' }}>
                <Button
                  sx={{ minHeight: 120, borderRadius: '20px', boxShadow: 12, border: "2px solid #FFF" }}
                  fullWidth
                  variant="contained"
                  size="large"
                  startIcon={<UploadIcon sx={{ width: 55, height: 55, color: "#89B219" }} />}
                  onClick={() => navigate("/main/trayimportdashboard")}
                >
                  <Typography variant="h5" fontWeight="700" sx={{}}>TRAY IMPORT</Typography>
                </Button>
              </Item>
            </Grid>
            {/*         <Grid item xs={12} md={3}>
              <Item sx={{ padding: 0, bgcolor: 'transparent', boxShadow: 'none' }}>
                <Button
                  sx={{ minHeight: 120, borderRadius: '20px', boxShadow: 12, border: "2px solid #FFF" }}
                  fullWidth
                  variant="contained"
                  size="large"
                  startIcon={<UserIcon sx={{ width: 55, height: 55, color: "#89B219" }} />}
                  onClick={() => navigate("/hr/usersdashboard")}
                >
                  <Typography variant="h5" fontWeight="700" sx={{}}>USER MANAGEMENT</Typography>
                </Button>
              </Item>
            </Grid> */}
            {/* <Grid item xs={12} md={3}>
              <Item sx={{ padding: 0, bgcolor: 'transparent', boxShadow: 'none' }}>
                <Button
                  sx={{ minHeight: 120, borderRadius: '20px', boxShadow: 12, border: "2px solid #FFF" }}
                  fullWidth
                  variant="contained"
                  size="large"
                  startIcon={<GrassIcon sx={{ width: 55, height: 55, color: "#89B219" }} />}
                  onClick={() => navigate("/main/inventorydashboard")}
                >
                  <Typography variant="h5" fontWeight="700" sx={{}}>INVENTORY</Typography>
                </Button>
              </Item>
            </Grid> */}
            <Grid item xs={12} md={3}>
              <Item sx={{ padding: 0, bgcolor: 'transparent', boxShadow: 'none' }}>
                <Button
                  sx={{ minHeight: 120, borderRadius: '20px', boxShadow: 12, border: "2px solid #FFF" }}
                  fullWidth
                  variant="contained"
                  size="large"
                  startIcon={<SprayIcon sx={{ width: 55, height: 55, color: "#89B219" }} />}
                  onClick={() => navigate("/main/growingdashboard")}
                >
                  <Typography variant="h5" fontWeight="700" sx={{}}>GROWING</Typography>
                </Button>
              </Item>
            </Grid>
            <Grid item xs={12} md={3}>
              <Item sx={{ padding: 0, bgcolor: 'transparent', boxShadow: 'none' }}>
                <Button
                  sx={{ minHeight: 120, borderRadius: '20px', boxShadow: 12, border: "2px solid #FFF" }}
                  fullWidth
                  variant="contained"
                  size="large"
                  startIcon={<InvoiceIcon sx={{ width: 55, height: 55, color: "#89B219" }} />}
                  onClick={() => navigate("/invoicing/dashboard")}
                >
                  <Typography variant="h5" fontWeight="700" sx={{}}>INVOICING</Typography>
                </Button>
              </Item>
            </Grid>

            <Grid item xs={12} md={3}>
              <Item sx={{ padding: 0, bgcolor: 'transparent', boxShadow: 'none' }}>
                <Button
                  sx={{ minHeight: 120, borderRadius: '20px', boxShadow: 12, border: "2px solid #FFF" }}
                  fullWidth
                  variant="contained"
                  size="large"
                  startIcon={<ReceiptIcon sx={{ width: 55, height: 55, color: "#89B219" }} />}
                  onClick={() => navigate("/po/podashboard")}
                >
                  <Typography variant="h5" fontWeight="700" sx={{}}>PURCHASE ORDERS</Typography>
                </Button>
              </Item>
            </Grid>
            <Grid item xs={12} md={3}>
              <Item sx={{ padding: 0, bgcolor: 'transparent', boxShadow: 'none' }}>
                <Button
                  sx={{ minHeight: 120, borderRadius: '20px', boxShadow: 12, border: "2px solid #FFF" }}
                  fullWidth
                  variant="contained"
                  size="large"
                  startIcon={<SignpostIcon sx={{ width: 55, height: 55, color: "#89B219" }} />}
                  onClick={() => navigate("/logistics/dashboard")}
                >
                  <Typography variant="h5" fontWeight="700" sx={{}}>LOGISTICS</Typography>
                </Button>
              </Item>
            </Grid>
            <Grid item xs={12} md={3}>
              <Item sx={{ padding: 0, bgcolor: 'transparent', boxShadow: 'none' }}>
                <Button
                  sx={{ minHeight: 120, borderRadius: '20px', boxShadow: 12, border: "2px solid #FFF" }}
                  fullWidth
                  variant="contained"
                  size="large"
                  startIcon={<SeedingIcon sx={{ width: 55, height: 55, color: "#89B219" }} />}
                  onClick={() => navigate("/seeding/dashboard")}
                >
                  <Typography variant="h5" fontWeight="700" sx={{}}>SEEDING</Typography>
                </Button>
              </Item>
            </Grid>
            {/* <Grid item xs={12} md={3}>
              <Item sx={{ padding: 0, bgcolor: 'transparent', boxShadow: 'none' }}>
                <Button
                  sx={{ minHeight: 120, borderRadius: '20px', boxShadow: 12, border: "2px solid #FFF" }}
                  fullWidth
                  variant="contained"
                  size="large"
                  startIcon={<ShippingIcon sx={{ width: 55, height: 55, color: "#89B219" }} />}
                  onClick={() => navigate("/shipping/dashboard")}
                >
                  <Typography variant="h5" fontWeight="700" sx={{}}>SHIPPING</Typography>
                </Button>
              </Item>
            </Grid> */}
          </Grid>

        </Box>
      </section>
      <div>
        <BootstrapDialog
          onClose={handleClose}
          aria-labelledby="customized-dialog-title"
          open={open}
          maxWidth='xl'
          fullWidth
        >
          <BootstrapDialogTitle id="customized-dialog-title" onClose={handleClose}>
            VBM Modules
          </BootstrapDialogTitle>
          <DialogContent dividers>
            <ModuleMenu></ModuleMenu>
          </DialogContent>
        </BootstrapDialog>
      </div>
    </div>
  );
}
